import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const useAddEdit = () => {
  const navigate = useNavigate();
  const { id, action } = useParams();
  const location = useLocation();
  const isEdit = action == routes.edit;
  const isView = action == routes.view;
  const isAdd = action == routes.add;

  const pathParts = location.pathname.split("/");
  let addIndex, activeTab;

  if (id) {
    const actionIndex = pathParts.indexOf(action as string);
    activeTab = pathParts[actionIndex + 1] || routes.projectInfo;
  } else {
    addIndex = pathParts.indexOf("add");
    activeTab = pathParts[addIndex + 1] || routes.projectInfo;
  }

  const projectData = useSelector(
    (state: RootState) => state.currentData.projectData
  );

  const onBackClick = () => {
    navigate(`/${routes.admin}/${routes.projectOverview}`);
  };

  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.admin}/${routes.projectOverview}`,
        name: `Project Overview`,
      },
      {
        link: "",
        name:
          isEdit || isView
            ? `${projectData?.name} Project Details`
            : "Add Project",
      },
    ],
    [projectData]
  );

  const onTabClick = (value: string) => {
    if (id) {
      navigate(
        `/${routes.admin}/${routes.projectOverview}/${id}/${action}/${value}`
      );
    } else {
      navigate(
        `/${routes.admin}/${routes.projectOverview}/${routes.add}/${value}`
      );
    }
  };

  return {
    breadcrumbData,
    onBackClick,
    addIndex,
    activeTab,
    projectData,
    onTabClick,
    id,
    isAdd
  };
};

export default useAddEdit;
